import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Grid, Table } from "semantic-ui-react";
import _ from "lodash";
import PrintReportCaseHeader from "../PrintReportCaseHeader";
import ShowAllElements from "../Silver/ShowAllElements";

class PersonBljNimbusReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
    this.loadData(props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  onReportIndexChanged = (currentIndex) => {
    this.changeReport(currentIndex);
    const element = document.getElementById(`acc_${currentIndex}`);
    element.scrollIntoView();
  };

  onReportPrint = () => {
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = true;
    });
    this.setState({ accordionIndexes });
  };

  loadData = (props) => {
    if (props.reportData !== undefined) {
      const repRecords = _.get(props.reportData, "personBljReport.response[0].output[0].BLJReports[0].BLJReport");
      const accordionIndexes = [];
      _.forEach(repRecords, () => {
        accordionIndexes.push(false);
      });
      if (accordionIndexes.length > 0) accordionIndexes[0] = true;
      this.state = {
        activeIndex: 0,
        accordionIndexes,
      };
    }
  };

  // handleClick = (e, index) => {
  //   this.changeReport(index);
  // };

  // changeReport = (index) => {
  //   const { activeIndex } = this.state;
  //   const accordionIndexes = this.state.accordionIndexes;
  //   _.forEach(accordionIndexes, (acc, accIndex) => {
  //     accordionIndexes[accIndex] = false;
  //   });
  //   accordionIndexes[index] = !accordionIndexes[index];
  //   if (activeIndex !== index) {
  //     const newIndex = activeIndex === index ? -1 : index;
  //     this.setState({
  //       activeIndex: newIndex,
  //       accordionIndexes,
  //     });
  //   } else {
  //     this.setState({
  //       accordionIndexes,
  //     });
  //   }
  // };

  render() {
    const records = [];
    // const itemTitles = [];
    const {updateItemCountBySection} = this.props;
    let actId;
    if (this.props.reportData !== undefined) {
      actId = _.get(
        this.props.reportData,
        `${Object.keys(this.props.reportData)[0]}.log[0].actID[0]`
      );
      _.forEach(
        _.get(this.props.reportData, "personBljReport.response[0].output[0].BLJReports[0].BLJReport"),
        (record, index) => {
          records.push(<ShowAllElements
            {...this.props}
            level={4}
            sectionName={"Liens"}
            sectionTitle={"Liens"}
            node={_.get(
              record,
              `personalLienFilings[0].personalLienFiling`
            )}
            key={`rep_liens_${index}`}
            updateItemCountBySection={updateItemCountBySection}
          />);
          records.push(<ShowAllElements
            {...this.props}
            level={4}
            sectionName={"Judgments"}
            sectionTitle={"Judgments"}
            node={_.get(
              record,
              `personalJudgmentFilings[0].personalJudgmentFiling`
            )}
            key={`rep_judgment_${index}`}
            updateItemCountBySection={updateItemCountBySection}
          />);
          records.push(<ShowAllElements
            {...this.props}
            level={4}
            sectionName={"Bankruptcys"}
            sectionTitle={"Bankruptcys"}
            node={_.get(
              record,
              `personalBankruptcyFilings[0].personalBankruptcyFilings`
            )}
            key={`rep_bankruptcys_${index}`}
            updateItemCountBySection={updateItemCountBySection}
          />);
        }
      );
    }

    return (
      <Segment key="tabContent1" attached id={`report`}>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Table className={`no-print`}>
                <Table.Body>
                  <PrintReportCaseHeader
                    {...this.props}
                    actId={actId}
                    onReportPrint={this.onReportPrint}
                  />
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {/* <Grid.Column width={4}>
              <ReportSummary
                onReportIndexChanged={this.onReportIndexChanged}
                activeSummaryIndex={this.state.activeIndex}
                itemTitles={itemTitles}
              />
            </Grid.Column> */}
            <Grid.Column width={16}>
              {/* <Accordion fluid styled> */}
              {records}
              {/* </Accordion> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(PersonBljNimbusReport);



// WEBPACK FOOTER //
// ./src/components/reports/Civil/PersonBljNimbusReport.js